<template functional>
  <!-- eslint-disable -->
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12,7.25A4.75,4.75,0,1,0,16.75,12,4.756,4.756,0,0,0,12,7.25Zm0,8A3.25,3.25,0,1,1,15.25,12,3.254,3.254,0,0,1,12,15.25ZM11.25,5V3a.75.75,0,0,1,1.5,0V5a.75.75,0,0,1-1.5,0Zm1.5,14v2a.75.75,0,0,1-1.5,0V19a.75.75,0,0,1,1.5,0ZM5,12.75H3a.75.75,0,0,1,0-1.5H5a.75.75,0,0,1,0,1.5ZM21.75,12a.75.75,0,0,1-.75.75H19a.75.75,0,0,1,0-1.5h2A.75.75,0,0,1,21.75,12ZM5.106,6.166a.75.75,0,0,1,1.061-1.06L7.581,6.52A.75.75,0,0,1,6.52,7.581ZM18.894,17.834a.75.75,0,1,1-1.061,1.06L16.419,17.48a.75.75,0,0,1,1.061-1.061ZM7.581,16.419a.75.75,0,0,1,0,1.061L6.167,18.894a.75.75,0,0,1-1.061-1.06L6.52,16.419A.75.75,0,0,1,7.581,16.419Zm8.838-8.838a.75.75,0,0,1,0-1.061l1.414-1.414a.75.75,0,0,1,1.061,1.06L17.48,7.581a.752.752,0,0,1-1.061,0Z" />
  </svg>
</template>

<script>
export default {
  name: 'IconSun',
};
</script>